import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

export interface RemoveAddressRequest {
  addressId: number;
}

export interface DefaultAddressRequest {
  addressId: number;
}

export interface AddressSearchRequest {
  userId: number;
  offset: number;
  limit: number;
}

export interface AddressInputRequest {
  nome: string;
  logradouro: string;
  bairro: string;
  cep: string;
  cidade: string;
  numero: string;
  complemento: string;
  uf: string;
  ativo: Boolean;
  remetente: string;
  etiqueta: AddressInputRequest;
  coletaHabilitada: Boolean;
  logisticaReversaHabilitada: Boolean;
  devolucaoHabilitada: Boolean;
  areaDedicadaColeta: string;
}

export interface AddressResponseItem {
  id: number;
  nome: string;
  logradouro: string;
  bairro: string;
  cep: string;
  cidade: string;
  numero: string;
  complemento: string;
  uf: string;
  ativo: Boolean;
  remetente: string;
  latitude: number;
  longitude: number;
  enderecoDevolucao; boolean;
  etiqueta: AddressResponseItem;
}

@Injectable()
export class ProfileAddressApiService {
  private apiUrl = environment.angularJSconstants.URLAPICLIENTE;
  constructor(private http: HttpClient) {}

  public getAddresses(request: Partial<AddressSearchRequest>): Observable<AddressResponseItem[]> {
    return this.http.get<AddressResponseItem[]>(`${this.apiUrl}/clientes/${request.userId}/enderecos`);
  }

  public addAddress(request: Partial<AddressInputRequest>): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/v1/enderecos`, request);
  }

  public removeAddress(request: Partial<RemoveAddressRequest>): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/v1/enderecos/${request.addressId}`);
  }

  public updateAddressAsCollectDefault(request: Partial<DefaultAddressRequest>): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/v1/enderecos/${request.addressId}/coleta-padrao`, null);
  }

  public updateAddressAsReturnDefault(request: Partial<DefaultAddressRequest>): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/v1/enderecos/${request.addressId}/devolucao-padrao`, null);
  }

  public updateAddressAsLabelDefault(request: Partial<DefaultAddressRequest>): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/v1/enderecos/${request.addressId}/etiqueta-padrao`, null);
  }

  public setAwareOfAddressChanged(request: Partial<AddressSearchRequest>): Promise<any> {
    try {
      return this.http.put<any>(`${this.apiUrl}/clientes/${request}/ciencia-novo-endereco/`, null).toPromise();
    } catch (error) {}
  }

  public getAwareOfAddressChanged(request: Partial<AddressSearchRequest>): Promise<any> {
    try {
      return this.http.get<any>(`${this.apiUrl}/clientes/${request}/ciencia-novo-endereco/`).toPromise();
    } catch (error) {
      console.log(error);
    }
  }
}
